import React from "react";
// import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
//import noItems from "https://cdn.edusity.com/empty-boxes.svg";

export default function Error404() {
  // const { t } = useTranslation();

  return (
    <>
      <div className="container-wrapper">
        <div className="error-wrapper">
          <div className="back-wrapper">
            <Link to="/dashboard">{("404.backToDash")}</Link>
          </div>

          <div className="inner-wrapper">
            <div className="whoops">{("404.oops")}</div>
            <div className="hide">{window.location.pathname}</div>
            <div className="whoops">{("404.doesNotExist")}</div>

            <img
              alt="no items found"
              src="https://cdn.edusity.com/empty-boxes.svg"
            />
          </div>
        </div>
      </div>
    </>
  );
}
